import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "label", "spinner"]

  submitStart() {
    this.buttonTarget.disabled = true
    this.buttonTarget.setAttribute("aria-busy", "true")
    this.labelTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("hidden")
    this.spinnerTarget.classList.add("inline-flex")
  }

  submitEnd() {
    this.buttonTarget.disabled = false
    this.buttonTarget.removeAttribute("aria-busy")
    this.labelTarget.classList.remove("hidden")
    this.spinnerTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("inline-flex")
  }
}
